import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import QRCode from 'react-qr-code';
import { Link, NavLink, withRouter } from 'react-router-dom';
import geofencingImg from '../../../../../assets/images/geofencing.png';
import geolocationImg from '../../../../../assets/images/geolocation.png';
import tabletbiometricsImg from '../../../../../assets/images/tabletbiometrics.png';
import AlertService from '../../../../../components/SweetAlert';
import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';

import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Nav,
  NavItem,
  Row,
  TabContent,
  TabPane,
  NavLink as VerticalNavLink,
} from 'reactstrap';

import { Form } from 'react-bootstrap';

import classnames from 'classnames';

import mapboxgl from 'mapbox-gl'; // This is a dependency of react-map-gl even if you didn't explicitly install it
import Map, {
  FullscreenControl,
  GeolocateControl,
  MapProvider,
  Marker,
  NavigationControl,
  Popup,
  useMap,
} from 'react-map-gl';
import { config } from '../../../../../config/index';
import { GET, POST, PUT, newFetch } from '../../../../../helpers/fetch';
import { to12Hr } from '../../../../../helpers/moment';

// prettier-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

const {
  API_URL,
  ASSOCIATE_URL,
  MAP_BOX_API_URL,
  MAP_BOX_GEOCODING_URL,
  MAP_BOX_API_TOKEN,
} = config;

const SiteDetail = ({ history, match: { params } }) => {
  const client_id = parseInt(params.client_id);
  const site_id = parseInt(params.site_id);
  const token = localStorage.getItem('token');
  const [qrCodeValue, setQrCodeValue] = useState(
    ASSOCIATE_URL + `/client/site/${parseInt(params.site_id)}`
  );
  const [activeTab, setActiveTab] = useState('general');
  const [announcementName, setAnnouncementName] = useState('');
  const [announcementStatus, setAnnouncementStatus] = useState('');
  const [messsage, setMessage] = useState('');
  const [cnMessage, setCnMessage] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({ id: '' });
  const [data, setData] = React.useState([]);
  const [announcementList, setAnnouncementList] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });
  const [loadingAnnouncement, setLoadingAnnouncement] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [sortModel, setSortModel] = useState([
    { field: 'updatedAt', sort: 'desc' }, // Initial sort field and order
  ]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [claimApprovers, setClaimApprovers] = useState([]);

  const [client, setClient] = useState({});
  const [site, setSite] = useState({});
  const [shifts, setShifts] = useState([]);
  const [ttGroups, setTTGroups] = useState([]);

  const [name, setName] = useState('');
  const [managerName, setManagerName] = useState('');
  const [managerEmail, setManagerEmail] = useState('');
  const [managerPhoneNo, setManagerPhoneNo] = useState('');

  const [verticalActiveTab, setverticalActiveTab] = useState('2');
  const [validated, setValidated] = useState(false);
  const [startDaySetting, setStartDaySetting] = useState(0);

  const [cards, setCards] = useState([]);
  const [rollCallCards, setRollCallCards] = useState([]);

  const [fixBreakCards, setFixBreakCards] = useState([]);

  const [loading, setLoading] = useState(false);
  const [siteMapSearchKey, setSiteMapSearchKey] = useState('');
  const [siteMapSearchResult, setSiteMapSearchResult] = useState([]);
  const [selectedSearchResult, setSelectedSearchResult] = useState('');
  const [siteMapDistance, setSiteMapDistance] = useState('');
  const [viewState, setViewState] = React.useState({
    longitude: 103.8307668795241,
    latitude: 1.3277931546983268,
    zoom: 10.697175623863698,
    pitch: 40.53850326912702,
    bearing: -15.886689408000393,
  });
  const [viewMarkerState, setMarkerState] = React.useState({
    longitude: 0,
    latitude: 0,
  });
  const [showPopup, setShowPopup] = React.useState(true);
  const mapRef = useRef(null);
  const [viewport, setViewport] = useState({
    longitude: -122.4376,
    latitude: 37.7577,
    zoom: 8,
  });

  const [schedule, setSchedule] = useState({
    Monday: { startTime: '', endTime: '' },
    Tuesday: { startTime: '', endTime: '' },
    Wednesday: { startTime: '', endTime: '' },
    Thursday: { startTime: '', endTime: '' },
    Friday: { startTime: '', endTime: '' },
    Saturday: { startTime: '', endTime: '' },
    Sunday: { startTime: '', endTime: '' },
  });

  const [settings, setSettings] = useState({
    enable_geolocation: false,
    enable_geofencing: false,
    enable_tablet_biometrics: false,
    enable_capture_photo: false,
    enable_multiple_clockinout: false,
    enable_face_recognition: false,
    enable_preferred_schedule: false,
    enable_br_upload: false,
    enable_pick_rate: false,
    enable_credit_rewards: false,
    enable_schedule_upload: false,
    enable_roll_calls: false,
    enable_assign_multiple_roles: false,
    enable_upload_timesheet: false,
    enable_cron_daily_tracker_report: false,
    enable_cron_green_badge_report: false,
    enable_cron_weekly_business_report: false,
    enable_dl_weekly_reports: false,
    enable_dl_monthly_reports: false,
    enable_checklist: false,
    enable_auto_scheduling: false,
    enable_claim_limit: false,
    enable_claim_percentage: false,
    enable_claim_receipt: false,
    enable_ss_claim_limit: false,
    enable_fix_break: false,
    lng: 0,
    lat: 0,
    distance: null,
  });

  const siteMapDistanceHandler = (e) => {
    setSiteMapDistance(e.target.value);
    setSettings((prevSettings) => ({
      ...prevSettings,
      distance: e.target.value,
    }));
  };

  const startDayHandler = (e) => {
    // setStartDaySetting(e.target.value);
    const { name, value } = e.target;
    setSettings((prevSettings) => ({
      ...prevSettings,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    // Geolocation ↔ Geofencing (mutually exclusive)
    if (name === 'enable_geolocation') {
      setSettings((prev) => ({
        ...prev,
        enable_geolocation: checked,
        enable_geofencing: checked ? false : prev.enable_geofencing,
      }));
      return;
    }

    if (name === 'enable_geofencing') {
      setSettings((prev) => ({
        ...prev,
        enable_geofencing: checked,
        enable_geolocation: checked ? false : prev.enable_geolocation,
      }));
      return;
    }

    if (name === 'enable_capture_photo') {
      setSettings((prev) => ({
        ...prev,
        enable_capture_photo: checked,
        enable_face_recognition: checked ? false : prev.enable_face_recognition,
      }));
      return;
    }

    if (name === 'enable_face_recognition') {
      setSettings((prev) => ({
        ...prev,
        enable_face_recognition: checked,
        enable_capture_photo: checked ? false : prev.enable_capture_photo,
      }));
      return;
    }

    setSettings((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      await submitHandler(event);
    }

    setValidated(true);
  };

  const handleSubmitScheduler = async (event) => {
    event.preventDefault();

    if (siteMapDistance && !/^\d+(\.\d+)?$/.test(siteMapDistance)) {
      ToastUtil.error('Please enter numbers only for site map distance.');
      return;
    }

    if (!validateCards()) return;
    if (!validateRollCallCards()) return;
    if (!validateFixBreakCards()) return;

    if (settings.enable_geofencing === false) {
      setSettings(({ lng, lat, distance, ...rest }) => ({
        ...rest,
      }));
    }

    const url = `${API_URL}/client/${client_id}/site/setting/${site_id}`;
    const token = localStorage.getItem('token');

    try {
      // Save main settings
      const response = await fetch(url, {
        method: 'PUT',
        body: JSON.stringify(settings),
        withCredentials: true,
        mode: 'cors',
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      const responseData = await response.json();

      // Submit Checklist
      let submit_site_path = `/client/${client_id}/site/${site_id}/create-update-checklist`;
      await newFetch(POST, submit_site_path, cards);

      // Submit Roll Calls
      let submit_roll_call_path = `/client/${client_id}/site/${site_id}/create-update-roll-calls`;
      await newFetch(POST, submit_roll_call_path, rollCallCards);

      // Submit Fix Break Rules
      if (settings.enable_fix_break) {
        let submit_fix_break_path = `/client/${client_id}/site/${site_id}/create-update-fix-break`;
        await newFetch(POST, submit_fix_break_path, fixBreakCards);
      }

      ToastUtil.success(responseData.message);
    } catch (error) {
      ToastUtil.error(error);
    }
  };

  const handleSubmitClaimSettingsHandler = async (event) => {
    event.preventDefault();

    await handleSubmitClaimApprover();
    await handleSubmitClaimSettings();
  };

  const handleSubmitClaimApprover = async () => {
    if (!validateApprovers()) {
      return;
    }

    try {
      let submit_site_path = `/client/${client_id}/site/${site_id}/create-update-claimapprover`;
      const response = await newFetch(POST, submit_site_path, claimApprovers);

      if (response.success) {
        ToastUtil.success(`Claim approvers updated successfully.`);
      } else {
        ToastUtil.error(
          `Failed to update claim approvers: ${response.message}`
        );
      }
    } catch (error) {
      console.error('Error in handleSubmitClaimApprover:', error);
      ToastUtil.error('An unexpected error occurred. Please try again.');
    }
  };

  const handleSubmitClaimSettings = async () => {
    const url = `${API_URL}/client/${client_id}/site/setting/${site_id}`;
    const token = localStorage.getItem('token');

    try {
      const response = await fetch(url, {
        method: 'PUT',
        body: JSON.stringify(settings),
        withCredentials: true,
        mode: 'cors',
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      const responseData = await response.json();

      // Handle response
      ToastUtil.success(responseData.message);
    } catch (error) {
      ToastUtil.error(error);
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    let msg = 'Are you sure you want to update this Site?';

    msg = !site.active
      ? `Editing deactivated sites will reactivate the site. ${msg}`
      : msg;

    // if (await AlertService.confirm("", msg)) {
    //   let response_shifts = await submitShifts();

    //   // let shiftResponseData = await response_shifts.json()

    //   let shiftErr = response_shifts.find((res) => !res.success);

    //   if (shiftErr) {
    //     ToastUtil.error(`Shift Error: ${shiftErr.message}`);
    //   } else {
    //     let response_site = await submitSite();

    //     let siteResponseData = await response_site.json();

    //     if (siteResponseData.success) {
    //       ToastUtil.success(siteResponseData.message);
    //       window.location.replace(
    //         `${window.location.origin}/clients/client/${client_id}/sites/site/${site_id}`
    //       );
    //     } else {
    //       ToastUtil.error(siteResponseData.message);
    //     }
    //   }
    // }
  };

  const discardHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to discard all changes?'
      )
    ) {
      setName(site.name);
      setManagerName(site.manager_name);
      setManagerEmail(site.manager_email);
      setManagerPhoneNo(site.manager_phone_no);
    }
  };

  const handleInputChange = (day, field, value) => {
    setSchedule((prevSchedule) => ({
      ...prevSchedule,
      [day]: {
        ...prevSchedule[day],
        [field]: value,
      },
    }));
  };

  const onImageDownload = () => {
    const svg = document.getElementById('QRCode');
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL('image/png');
      const downloadLink = document.createElement('a');
      downloadLink.download = `${site.name}_QRCode`;
      downloadLink.href = `${pngFile}`;
      downloadLink.click();
    };
    img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
  };

  const fetchClient = async () => {
    const url = `${API_URL}/client/${client_id}`;

    if (token) {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        let data = await response.json();

        setClient(data.data);
      } else {
        console.log(response.message);
      }
    } else {
      console.log('Token is missing');
    }
  };

  const fetchSite = async () => {
    const url = `${API_URL}/sites`;

    if (token) {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        let data = await response.json();

        let sites = data.data;
        let site = sites.find((site) => site.id === site_id);
        setSite(site);
        setSettings({
          enable_geolocation: site.enable_geolocation,
          enable_geofencing: site.enable_geofencing,
          enable_tablet_biometrics: site.enable_tablet_biometrics,
          enable_capture_photo: site.enable_capture_photo,
          enable_multiple_clockinout: site.enable_multiple_clockinout,
          enable_face_recognition: site.enable_face_recognition,
          enable_preferred_schedule: site.enable_preferred_schedule,
          enable_br_upload: site.enable_br_upload,
          enable_pick_rate: site.enable_pick_rate,
          enable_credit_rewards: site.enable_credit_rewards,
          enable_schedule_upload: site.enable_schedule_upload,
          enable_roll_calls: site.enable_roll_calls,
          enable_assign_multiple_roles: site.enable_assign_multiple_roles,
          enable_upload_timesheet: site.enable_upload_timesheet,
          enable_cron_daily_tracker_report:
            site.enable_cron_daily_tracker_report,
          enable_cron_green_badge_report: site.enable_cron_green_badge_report,
          enable_cron_weekly_business_report:
            site.enable_cron_weekly_business_report,
          enable_dl_weekly_reports: site.enable_dl_weekly_reports,
          enable_dl_monthly_reports: site.enable_dl_monthly_reports,
          enable_checklist: site.enable_checklist,
          enable_fix_break: site.enable_fix_break,
          enable_auto_scheduling: site.enable_auto_scheduling,
          enable_claim_limit: site.enable_claim_limit,
          enable_claim_percentage: site.enable_claim_percentage,
          enable_claim_receipt: site.enable_claim_receipt,
          enable_ss_claim_limit: site.enable_ss_claim_limit,
          lng: site.longitude || 0,
          lat: site.latitude || 0,
          distance: site.distance,
        });
        setMarkerState({
          longitude: site.lng || 0,
          latitude: site.lat || 0,
        });
        setSiteMapDistance(site.distance);
      } else {
        console.log(response.message);
      }
    } else {
      console.log('Token is missing');
    }
  };

  const fetchSiteChecklist = async () => {
    const url = `${API_URL}/site/${site_id}/checklists`;

    if (token) {
      try {
        let response = await fetch(url, {
          mode: 'cors',
          method: 'GET',
          withCredentials: true,
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8',
          },
        });

        if (response.ok) {
          let data = await response.json();

          // Sort the data array by the `sort` property in ascending order
          const sortedData = data.data.sort((a, b) => a.sort - b.sort);

          // Map sorted data into the required card format
          const cards = sortedData.map((item) => ({
            id: String(item.id),
            text: item.question,
            dropdownValue: item.data_type,
            order: item.sort,
            options: item.options || [], // Include options from backend response
          }));

          // Set the sorted and formatted cards
          setCards(cards);
        } else {
          console.log('Error:', response.message);
        }
      } catch (error) {
        console.error('Fetch error:', error);
      }
    } else {
      console.log('Token is missing');
    }
  };

  const fetchSiteFixBreaks = async () => {
    const url = `${API_URL}/site/${site_id}/fix-breaks`;

    if (token) {
      try {
        const response = await fetch(url, {
          mode: 'cors',
          method: 'GET',
          withCredentials: true,
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8',
          },
        });

        if (response.ok) {
          const result = await response.json();
          const data = result.data || [];

          const sortedData = data.sort((a, b) => a.id - b.id);

          const formatted = sortedData.map((item, index) => ({
            id: String(item.id),
            condition: item.condition,
            work_hrs: typeof item.work_hrs === 'number' ? item.work_hrs : '',
            break_mins:
              typeof item.break_mins === 'number' ? item.break_mins : '',
            order: item.order || index + 1,
          }));

          setFixBreakCards(formatted);
        } else {
          console.error('Error:', response.message);
        }
      } catch (error) {
        console.error('Fetch error:', error);
      }
    } else {
      console.error('Token missing');
    }
  };

  const fetchSiteRollCalls = async () => {
    const url = `${API_URL}/site/${site_id}/rollcalls`;

    if (token) {
      try {
        let response = await fetch(url, {
          mode: 'cors',
          method: 'GET',
          withCredentials: true,
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8',
          },
        });

        if (response.ok) {
          let data = await response.json();

          const rollcalls = data.data.map((item) => ({
            id: String(item.id),
            title: item.title,
            hours: item.hours,
            status: item.status ? 1 : 0,
            message: item.message,
          }));

          setRollCallCards(rollcalls);
        } else {
          console.log('Error:', response.message);
        }
      } catch (error) {
        console.error('Fetch error:', error);
      }
    } else {
      console.log('Token is missing');
    }
  };

  const fetchClaimApprovers = async () => {
    const url = `${API_URL}/client/${client_id}/site/${site_id}/claimapprovers`;

    if (!token) {
      console.log('Token is missing');
      return;
    }

    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        let data = await response.json();

        if (data.success) {
          // Transform response to match the expected structure
          const approvers = data.data.map((item, index) => ({
            id: `${Date.now()}_${index}`, // Set unique id
            value: item.type, // Set value as type
          }));

          setClaimApprovers(approvers);
        } else {
          console.log('Error:', data.message);
        }
      } else {
        console.log('HTTP Error:', response.statusText);
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };

  const fetchShifts = async () => {
    const url = `${API_URL}/site/${site_id}/shifts`;

    if (token) {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        let data = await response.json();
        let shiftsData = data.data;

        setShifts(shiftsData);
      } else {
        console.log(response.message);
      }
    } else {
      console.log('Token is missing');
    }
  };

  const fetchTTGroups = async () => {
    let api_path = `/site/${site_id}/ttgroup`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setTTGroups(response.data);
    }
  };

  const toggleVertical = (tab) => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab);
    }
  };

  const addCard = (e) => {
    e.preventDefault();
    const cardsArray = Array.isArray(cards) ? cards : [];
    const largestOrder =
      cardsArray.length > 0
        ? Math.max(...cardsArray.map((card) => card.order))
        : 0;
    const newOrder = largestOrder + 1;

    setCards([
      ...cardsArray,
      {
        id: String(Math.floor(Math.random() * 90000) + 10001), // Generates a number between 10001 and 99999
        text: '',
        dropdownValue: '',
        order: newOrder,
        options: [],
      },
    ]);
  };

  const updateCard = (index, key, value) => {
    const updatedCards = [...cards];
    updatedCards[index][key] = value;

    // Initialize or reset options based on dropdownValue
    if (key === 'dropdownValue') {
      if (value === 'dropdown') {
        // Ensure options array exists when switching to dropdown
        updatedCards[index].options = updatedCards[index].options || [];
      } else {
        // Reset options if switching away from dropdown
        updatedCards[index].options = [];
      }
    }

    setCards(updatedCards);
  };

  const addOption = (e, cardIndex) => {
    e.preventDefault();
    const updatedCards = [...cards];
    updatedCards[cardIndex].options.push({
      id: '',
      option_value: '',
      option_label: '',
    });
    setCards(updatedCards);
  };

  const updateOption = (cardIndex, optionIndex, key, value) => {
    const updatedCards = [...cards];
    updatedCards[cardIndex].options[optionIndex][key] = value;
    setCards(updatedCards);
  };

  const removeOption = (cardIndex, optionIndex) => {
    const updatedCards = [...cards];
    updatedCards[cardIndex].options.splice(optionIndex, 1);
    setCards(updatedCards);
  };

  // Remove Card
  const removeCard = (index) => {
    const updatedCards = cards.filter((_, i) => i !== index);
    setCards(updatedCards);
  };

  // Handle Drag-and-Drop Reordering
  const handleDragEnd = (result) => {
    if (!result.destination) return; // If dropped outside a droppable area, do nothing.

    const reorderedCards = Array.from(cards);
    const [removed] = reorderedCards.splice(result.source.index, 1);
    reorderedCards.splice(result.destination.index, 0, removed);

    const updatedCards = reorderedCards.map((card, index) => ({
      ...card,
      order: index + 1,
    }));

    setCards(updatedCards);
  };

  const validateCards = () => {
    const errors = [];

    cards.forEach((card, index) => {
      if (!card.text.trim()) {
        errors.push(`Row ${index + 1}: Text cannot be empty.`);
      }

      if (!card.dropdownValue) {
        errors.push(`Row ${index + 1}: Please select a dropdown option.`);
      }

      // Validate dropdown options if the selected dropdown type is 'dropdown'
      if (card.dropdownValue === 'dropdown') {
        if (card.options.length === 0) {
          errors.push(
            `Row ${index + 1}: Dropdown must have at least one option.`
          );
        }

        card.options.forEach((option, optionIndex) => {
          if (!option.option_value.trim()) {
            errors.push(
              `Row ${index + 1}, Option ${
                optionIndex + 1
              }: Option Value cannot be empty.`
            );
          }

          if (!option.option_label.trim()) {
            errors.push(
              `Row ${index + 1}, Option ${
                optionIndex + 1
              }: Option Label cannot be empty.`
            );
          }
        });
      }
    });

    if (errors.length > 0) {
      // Show all errors in a single toast message
      const errorMessage = `Checklist error:\n\n${errors.join('\n')}`;
      ToastUtil.error(errorMessage);
      return false;
    }

    return true;
  };

  const validateFixBreakCards = () => {
    const errors = [];

    if (settings.enable_fix_break) {
      if (!Array.isArray(fixBreakCards) || fixBreakCards.length === 0) {
        errors.push('Please add at least one Fix Break rule.');
      }

      fixBreakCards.forEach((card, index) => {
        const workHrsStr =
          card.work_hrs !== undefined && card.work_hrs !== null
            ? String(card.work_hrs).trim()
            : '';

        const breakMinsStr =
          card.break_mins !== undefined && card.break_mins !== null
            ? String(card.break_mins).trim()
            : '';

        if (!card.condition) {
          errors.push(`Fix Break Row ${index + 1}: Please select a condition.`);
        }

        if (!workHrsStr) {
          errors.push(
            `Fix Break Row ${index + 1}: Work Hours cannot be empty.`
          );
        } else if (!/^\d+(\.\d{1,2})?$/.test(workHrsStr)) {
          errors.push(
            `Fix Break Row ${
              index + 1
            }: Work Hours must be a valid number (e.g., 0.00).`
          );
        } else if (parseFloat(workHrsStr) < 0) {
          errors.push(
            `Fix Break Row ${index + 1}: Work Hours cannot be negative.`
          );
        }

        if (!breakMinsStr) {
          errors.push(
            `Fix Break Row ${index + 1}: Break Minutes cannot be empty.`
          );
        } else if (!/^\d+(\.\d{1,2})?$/.test(breakMinsStr)) {
          errors.push(
            `Fix Break Row ${
              index + 1
            }: Break Minutes must be a valid number (e.g., 0.00).`
          );
        } else if (parseFloat(breakMinsStr) < 0) {
          errors.push(
            `Fix Break Row ${index + 1}: Break Minutes cannot be negative.`
          );
        }
      });
    }

    if (errors.length > 0) {
      const errorMessage = `Fix Break error:\n\n${errors.join('\n')}`;
      ToastUtil.error(errorMessage);
      return false;
    }

    return true;
  };

  const validateApprovers = () => {
    const errors = [];

    claimApprovers.forEach((approver, index) => {
      if (!approver.value) {
        errors.push(
          `For Approver ${index + 1}: Please select an approver.\n\n`
        );
      }
    });

    if (errors.length > 0) {
      // Show all errors in a single toast message
      const errorMessage = `Error:\n\n${errors.join('\n')}`;
      ToastUtil.error(errorMessage);
      return false;
    }

    return true;
  };

  const addRollCallCard = (e) => {
    e.preventDefault();
    const cardsArray = Array.isArray(rollCallCards) ? rollCallCards : [];
    const largestOrder =
      cardsArray.length > 0
        ? Math.max(...cardsArray.map((card) => card.order))
        : 0;
    const newOrder = largestOrder + 1;

    setRollCallCards([
      ...cardsArray,
      {
        id: '', // Generates a number between 10001 and 99999
        status: '',
        hours: '',
        title: '',
        message: '',
        order: newOrder,
      },
    ]);
  };

  const updateRollCallCard = (index, key, value) => {
    const updatedCards = [...rollCallCards];
    updatedCards[index][key] = value;
    setRollCallCards(updatedCards);
  };

  // Remove Card
  const removeRollCallCard = (index) => {
    const updatedCards = rollCallCards.filter((_, i) => i !== index);
    setRollCallCards(updatedCards);
  };

  const validateRollCallCards = () => {
    const errors = [];

    rollCallCards.forEach((rollCall, index) => {
      if (rollCall.status === '') {
        errors.push(`Roll Call ${index + 1}: Please select a status.`);
      }

      if (!rollCall.hours) {
        errors.push(`Roll Call ${index + 1}: Hours cannot be empty.`);
      }

      if (!rollCall.title) {
        errors.push(`Roll Call ${index + 1}: Title cannot be empty.`);
      }

      if (!rollCall.message) {
        errors.push(`Roll Call ${index + 1}: Message cannot be empty.`);
      }
    });

    if (errors.length > 0) {
      // Show all errors in a single toast message
      const errorMessage = `Error:\n\n${errors.join('\n')}`;
      ToastUtil.error(errorMessage);
      return false;
    }

    return true;
  };

  // Add a new Fix Break Card
  const addFixBreakCard = (e) => {
    e.preventDefault();

    const cardsArray = Array.isArray(fixBreakCards) ? fixBreakCards : [];
    const largestOrder =
      cardsArray.length > 0
        ? Math.max(...cardsArray.map((card) => card.order || 0))
        : 0;
    const newOrder = largestOrder + 1;

    setFixBreakCards([
      ...cardsArray,
      {
        id: String(Math.floor(Math.random() * 90000) + 10001),
        condition: '',
        work_hrs: '',
        break_mins: '',
        order: newOrder,
      },
    ]);
  };

  // Update Fix Break Card field
  const updateFixBreakCard = (index, key, value) => {
    const updatedCards = [...fixBreakCards];
    updatedCards[index][key] = value;
    setFixBreakCards(updatedCards);
  };

  // Remove Fix Break Card
  const removeFixBreakCard = (index) => {
    const updatedCards = fixBreakCards.filter((_, i) => i !== index);
    setFixBreakCards(updatedCards);
  };

  // Handle drag and drop reordering
  const handleFixBreakDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedCards = Array.from(fixBreakCards);
    const [removed] = reorderedCards.splice(result.source.index, 1);
    reorderedCards.splice(result.destination.index, 0, removed);

    const updatedCards = reorderedCards.map((card, index) => ({
      ...card,
      order: index + 1,
    }));

    setFixBreakCards(updatedCards);
  };

  const nameHandler = (e) => setName(e.target.value);
  const managerNameHandler = (e) => setManagerName(e.target.value);
  const managerEmailHandler = (e) => setManagerEmail(e.target.value);
  const managerPhoneNoHandler = (e) => setManagerPhoneNo(e.target.value);

  const announcementNameHandler = (e) => setAnnouncementName(e.target.value);
  const announcementStatusHandler = (e) =>
    setAnnouncementStatus(e.target.value);
  const messageHandler = (e) => setMessage(e.target.value);
  const cnMessageHandler = (e) => setCnMessage(e.target.value);

  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      flex: 1,
      resizable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <div className="row">
            <div className="col-md-12">
              <Link
                className="text-primary "
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleEdit(params.row);
                }}
              >
                <span
                  style={{
                    fontWeight: '700',
                    fontSize: 14,
                  }}
                >
                  {params.row.id}
                </span>
              </Link>
            </div>
          </div>
        );
      },
    },
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
      sortable: false,
      resizable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <span style={{ color: '#212529', fontSize: 15, fontWeight: 400 }}>
            {params.row.name || '--'}
          </span>
        );
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      sortable: false,
      resizable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <span style={{ color: '#212529', fontSize: 15, fontWeight: 400 }}>
            {params.row.status == 1 ? 'Active' : 'Inactive'}
          </span>
        );
      },
    },
    {
      field: 'display_from',
      headerName: 'Display From',
      flex: 1,
      sortable: false,
      resizable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <span style={{ color: '#212529', fontSize: 15, fontWeight: 400 }}>
            {params.row.display_from
              ? moment(params.row.display_from, 'YYYY-MM-DD').format(
                  'DD/MM/YYYY'
                )
              : '--'}
          </span>
        );
      },
    },
    {
      field: 'display_to',
      headerName: 'Display To',
      flex: 1,
      sortable: false,
      resizable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <span style={{ color: '#212529', fontSize: 15, fontWeight: 400 }}>
            {params.row.display_to
              ? moment(params.row.display_to, 'YYYY-MM-DD').format('DD/MM/YYYY')
              : '--'}
          </span>
        );
      },
    },
  ];

  const handleSortModelChange = (newSortModel) => {
    setSortModel(newSortModel);
  };

  const handleAdd = () => {
    setFormData({ id: '' });
    setAnnouncementName('');
    setAnnouncementStatus('');
    setStartDate(new Date());
    setEndDate(new Date());
    setMessage('');
    setCnMessage('');
    setIsEditing(true);
  };

  const handleEdit = (row) => {
    setFormData(row);
    setAnnouncementName(row.name);
    setAnnouncementStatus(row.status);
    setStartDate(new Date(row.display_from));
    setEndDate(new Date(row.display_to));
    setMessage(row.announcement);
    setCnMessage(row.announcement_cn || '');
    setIsEditing(true);
  };

  const handleCancel = async () => {
    setIsEditing(false);
    setCnMessage('');
  };

  const fetchAnnouncement = async (pagination, field, sort) => {
    setLoadingAnnouncement(true);
    let api_path = `/announcement/list`;
    let response = await newFetch(POST, api_path, {
      field,
      sort,
      page: pagination.page,
      pageSize: pagination.pageSize,
      site_id: site_id,
    });

    if (response.success) {
      const announcementData = response.data.list;
      setAnnouncementList(announcementData);
      setTotalRows(response.data.total_record);
    } else setAnnouncementList([]);

    setLoadingAnnouncement(false);
  };

  const validateForm = () => {
    if (!announcementName) {
      ToastUtil.error('Please input a Name.');
      return false;
    }

    if (announcementStatus === '') {
      ToastUtil.error('Please select a Status!');
      return false;
    }

    if (!startDate) {
      ToastUtil.error('Please input a Display from.');
      return false;
    }

    if (!endDate) {
      ToastUtil.error('Please input a Display to.');
      return false;
    }

    if (!messsage) {
      ToastUtil.error('Please input a Messsage.');
      return false;
    }

    return true;
  };

  const handleSubmitAnnouncement = async (e) => {
    e.preventDefault();

    if (!formData.id) {
      if (
        validateForm() &&
        (await AlertService.confirm(
          '',
          'Are you sure you want to add new Announcement?'
        ))
      ) {
        let api_path = `/announcement`;
        let response = await newFetch(POST, api_path, {
          name: announcementName,
          status: announcementStatus,
          display_from: moment(startDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          display_to: moment(endDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          announcement: messsage,
          announcement_cn: cnMessage,
          site_id,
        });

        ToastUtil.success(response.message);

        if (response.success) {
          setIsEditing(false);
          fetchAnnouncement({
            pageSize: 10,
            page: 0,
          });
        } else {
          ToastUtil.error(response.message);
        }
      }
    } else {
      if (validateForm() && formData.id != '') {
        let api_path = `/announcement/${formData.id}`;
        let response = await newFetch(PUT, api_path, {
          name: announcementName,
          status: announcementStatus,
          display_from: moment(startDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          display_to: moment(endDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          announcement: messsage,
          announcement_cn: cnMessage,
        });

        ToastUtil.success(response.message);

        if (response.success) {
          setIsEditing(false);
          fetchAnnouncement({
            pageSize: 10,
            page: 0,
          });
        } else {
          ToastUtil.error(response.message);
        }
      }
    }
  };

  const CustomInput = React.forwardRef(
    ({ value, onClick, placeholder }, ref) => (
      <div>
        <input
          type="text"
          onClick={onClick}
          ref={ref}
          value={value}
          placeholder={placeholder}
          className="form-control"
          readOnly
        />
      </div>
    )
  );

  useEffect(() => {
    setData(announcementList !== undefined ? announcementList : []);

    announcementList !== undefined && setLoadingAnnouncement(false);
  }, [announcementList]);

  useEffect(() => {
    const { field, sort } = sortModel[0] || {};
    fetchAnnouncement(paginationModel, field, sort);
  }, [sortModel, paginationModel]);

  useEffect(() => {
    fetchClient();
    fetchSite();
    fetchSiteChecklist();
    fetchSiteFixBreaks();
    fetchShifts();
    fetchTTGroups();
    fetchSiteRollCalls();
    fetchSiteRollCalls();
    fetchClaimApprovers();
  }, []);

  useEffect(() => {
    siteMapSearchKey && fetchMapBoxPlaces();
  }, [siteMapSearchKey]);

  useEffect(() => {
    if (activeTab === '3') {
      mapRef.current?.resize(); // Only calls resize if mapRef.current exists
    }
  }, [activeTab]);

  useEffect(() => {
    setSettings((prevSettings) => ({
      ...prevSettings,
      lng: viewMarkerState.longitude,
      lat: viewMarkerState.latitude,
    }));
  }, [viewMarkerState]);

  const fetchMapBoxPlaces = async () => {
    const url = `${API_URL}/geocoding/${siteMapSearchKey}`;
    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        let data = await response.json();
        let coordinates = data.data;

        if (coordinates.features) {
          setTimeout(() => {
            setLoading(false);
            setSiteMapSearchResult(coordinates.features);
          }, 2000);
        }
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const NavigateButton = () => {
    const { siteMap } = useMap();

    const onClick = (center, index) => {
      siteMap.flyTo({ center: [center[0], center[1]], zoom: 14 });
      setMarkerState({
        longitude: center[0],
        latitude: center[1],
      });
      setSelectedSearchResult(index);
    };

    return (
      siteMapSearchResult &&
      siteMapSearchResult.map((item, index) => {
        return (
          <div key={index}>
            <button
              type="button"
              onClick={() => {
                onClick(item.center, index);
              }}
              className={`btn btn-outline-brand adjust-fs adjust-shadow ${
                selectedSearchResult === index && 'active'
              }`}
              style={{ width: '12rem' }}
            >
              {item.place_name}
            </button>
          </div>
        );
      })
    );
  };

  const siteMapSearchHandler = (e) => {
    setLoading(true);
    setSiteMapSearchKey(e.target.value);
  };

  // Function to add a new approver
  const addApprover = (e) => {
    e.preventDefault();
    setClaimApprovers([...claimApprovers, { id: Date.now(), value: '' }]);
  };

  const removeApprover = (id) => {
    setClaimApprovers(claimApprovers.filter((approver) => approver.id !== id));
  };

  // Function to handle changes in the select dropdown
  const handleApproverChange = (id, value) => {
    setClaimApprovers(
      claimApprovers.map((approver) =>
        approver.id === id ? { ...approver, value } : approver
      )
    );
  };

  return (
    <div>
      <div
        className="d-flex justify-content-between bg-white"
        style={{ padding: '3rem' }}
      >
        <div className="d-flex flex-column">
          <NavLink
            to={`/clients/client/${client_id}`}
            className="text-decoration-none"
            style={{ color: 'inherit' }}
          >
            <div>
              <i className="fas fa-chevron-left pe-2"></i> {client.name}
            </div>
          </NavLink>
          <div className="d-flex align-items-center justify-content-center pt-4">
            <i className="fas fa-warehouse fa-2x fa-fw"></i>
            <h3 className="pt-2 ps-3">{site.name}</h3>
          </div>
        </div>
        <div className="mt-auto">
          <button
            onClick={() =>
              history.push(
                `/clients/client/${client_id}/sites/site/${site.id}/edit`
              )
            }
            className="btn btn-outline-brand rounded adjust-fs adjust-shadow"
            style={{ width: '200px' }}
          >
            Edit Site
          </button>
        </div>
      </div>
      <div className="d-flex align-items-start">
        <div
          className="d-flex flex-column flex-grow-1"
          style={{ margin: '3rem' }}
        >
          <div
            className="d-flex justify-content-start"
            style={{ minWidth: 0, maxWidth: '94.6vw', overflowX: 'auto' }}
          >
            <div
              className="pb-3 flex-shrink-0"
              onClick={() => setActiveTab('general')}
            >
              <div
                style={
                  activeTab === 'general'
                    ? {
                        cursor: 'pointer',
                        marginRight: '1.5rem',
                        paddingBottom: '1rem',
                        marginBottom: '1rem',
                        borderBottom: '5px #5156BE solid',
                      }
                    : {
                        cursor: 'pointer',
                        marginRight: '1.5rem',
                        paddingBottom: '1rem',
                        marginBottom: '1rem',
                      }
                }
              >
                <strong
                  className={
                    activeTab === 'general' ? 'text-brand' : 'text-muted'
                  }
                >
                  General
                </strong>
              </div>
            </div>
            <div
              className="pb-3 flex-shrink-0"
              onClick={() => setActiveTab('tt')}
            >
              <div
                style={
                  activeTab === 'tt'
                    ? {
                        cursor: 'pointer',
                        marginRight: '1.5rem',
                        paddingBottom: '1rem',
                        marginBottom: '1rem',
                        borderBottom: '5px #5156BE solid',
                      }
                    : {
                        cursor: 'pointer',
                        marginRight: '1.5rem',
                        paddingBottom: '1rem',
                        marginBottom: '1rem',
                      }
                }
              >
                <strong
                  className={activeTab === 'tt' ? 'text-brand' : 'text-muted'}
                >
                  TT Groups
                </strong>
              </div>
            </div>
            <div
              className="pb-3 flex-shrink-0"
              onClick={() => setActiveTab('QrCode')}
            >
              <div
                style={
                  activeTab === 'QrCode'
                    ? {
                        cursor: 'pointer',
                        marginRight: '1.5rem',
                        paddingBottom: '1rem',
                        marginBottom: '1rem',
                        borderBottom: '5px #5156BE solid',
                      }
                    : {
                        cursor: 'pointer',
                        marginRight: '1.5rem',
                        paddingBottom: '1rem',
                        marginBottom: '1rem',
                      }
                }
              >
                <strong
                  className={
                    activeTab === 'QrCode' ? 'text-brand' : 'text-muted'
                  }
                >
                  QR Code
                </strong>
              </div>
            </div>
            <div
              className="pb-3 flex-shrink-0"
              onClick={() => setActiveTab('setting')}
            >
              <div
                style={
                  activeTab === 'setting'
                    ? {
                        cursor: 'pointer',
                        marginRight: '1.5rem',
                        paddingBottom: '1rem',
                        marginBottom: '1rem',
                        borderBottom: '5px #5156BE solid',
                      }
                    : {
                        cursor: 'pointer',
                        marginRight: '1.5rem',
                        paddingBottom: '1rem',
                        marginBottom: '1rem',
                      }
                }
              >
                <strong
                  className={
                    activeTab === 'setting' ? 'text-brand' : 'text-muted'
                  }
                >
                  Setting
                </strong>
              </div>
            </div>
          </div>
          {activeTab === 'general' ? (
            <div
              className="card bg-white text-dark shadow rounded py-3"
              style={{ paddingLeft: '2.25rem', paddingRight: '2.25rem' }}
            >
              <div className="card-body">
                <div className="d-flex flex-column">
                  <strong className="border-bottom py-2 mb-3">Threshold</strong>
                  <div className="d-flex flex-column">
                    <div className="row pb-3">
                      <div className="col-12">
                        <strong>Attendance rate threshold</strong>
                        <p style={{ fontSize: '2rem' }}>
                          {site.attendance_threshold}%
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <strong>Fill rate threshold</strong>
                        <p style={{ fontSize: '2rem' }}>
                          {site.fill_threshold}%
                        </p>
                      </div>
                    </div>
                  </div>
                  <strong className="border-bottom py-2 mb-3">
                    Default Shifts
                  </strong>
                  <div className="table-responsive">
                    <table className="table table-borderless border rounded">
                      <thead>
                        <tr className="border-bottom">
                          <th className="border-right">Shift Name</th>
                          <th className="text-center">Start Time</th>
                          <th className="text-center">End Time</th>
                        </tr>
                      </thead>

                      <tbody>
                        {shifts
                          .sort(
                            (a, b) =>
                              moment(a.start_time, 'HH:mm:ss') -
                              moment(b.start_time, 'HH:mm:ss')
                          )
                          .filter((data) => data.status)
                          .map((shift) => (
                            <tr key={shift.id}>
                              <td className="border-right">{shift.name}</td>
                              <td className="text-center">
                                {to12Hr(shift.start_time)}
                              </td>
                              <td className="text-center">
                                {to12Hr(shift.end_time)}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          ) : activeTab === 'tt' ? (
            <div
              className="card bg-white text-dark shadow rounded py-3"
              style={{ paddingLeft: '2.25rem', paddingRight: '2.25rem' }}
            >
              <div className="card-body">
                <div className="d-flex flex-column">
                  {ttGroups &&
                    ttGroups.length > 0 &&
                    ttGroups.map((group) => (
                      <button
                        key={group.id}
                        className="btn btn-block btn-brand text-start py-3"
                        onClick={() =>
                          history.push(
                            `/clients/client/${client_id}/sites/site/${site_id}/ttgroups/ttgroup/${group.id}`
                          )
                        }
                      >
                        <i className="fas fa-users mx-3"></i> {group.name}
                      </button>
                    ))}
                  <button
                    className="btn btn-block btn-outline-brand text-start py-3 adjust-fs adjust-shadow"
                    onClick={() =>
                      history.push(
                        `/clients/client/${client_id}/sites/site/${site_id}/ttgroups/add`
                      )
                    }
                  >
                    <i className="fas fa-plus mx-3"></i> Create New Group
                  </button>
                </div>
              </div>
            </div>
          ) : activeTab === 'QrCode' ? (
            <div
              className="card bg-white text-dark shadow rounded py-3"
              style={{ paddingLeft: '2.25rem', paddingRight: '2.25rem' }}
            >
              <div className="card-body">
                <div className="d-flex flex-column">
                  <div>
                    <div>
                      <QRCode
                        id="QRCode"
                        title="Custom Title"
                        value={qrCodeValue}
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-sm-12">
                      <strong>Site Link</strong>
                      <input
                        name="qrCodeValue"
                        type="text"
                        placeholder="Site Link"
                        className="form-control mt-3 adjust-fs"
                        value={qrCodeValue}
                        maxLength={150}
                        onChange={(e) => setQrCodeValue(e.target.value)}
                      />
                    </div>
                  </div>
                  <button
                    onClick={onImageDownload}
                    className="btn btn-brand mt-3 adjust-fs adjust-shadow"
                    style={{ width: '12rem' }}
                  >
                    Download
                  </button>
                </div>
              </div>
            </div>
          ) : activeTab === 'setting' ? (
            <Row>
              <Col>
                <Card>
                  <CardBody>
                    <Row>
                      <Col md="3">
                        <Nav pills className="flex-column">
                          <NavItem>
                            <VerticalNavLink
                              style={{ cursor: 'pointer' }}
                              className={classnames({
                                'mb-2': true,
                                active: verticalActiveTab === '2',
                              })}
                              onClick={() => {
                                toggleVertical('2');
                                setTimeout(() => {
                                  mapRef.current?.resize();
                                }, 50);
                              }}
                            >
                              Smart Scheduler
                            </VerticalNavLink>
                          </NavItem>
                          <NavItem>
                            <VerticalNavLink
                              style={{ cursor: 'pointer' }}
                              className={classnames({
                                active: verticalActiveTab === '3',
                              })}
                              onClick={() => {
                                toggleVertical('3');
                                setIsEditing(false);
                              }}
                            >
                              Announcement
                            </VerticalNavLink>
                          </NavItem>
                          {client && client.enable_claims && (
                            <NavItem>
                              <VerticalNavLink
                                style={{ cursor: 'pointer' }}
                                className={classnames({
                                  active: verticalActiveTab === '4',
                                })}
                                onClick={() => {
                                  toggleVertical('4');
                                  setIsEditing(false);
                                }}
                              >
                                Claims
                              </VerticalNavLink>
                            </NavItem>
                          )}
                        </Nav>
                      </Col>
                      <Col md="9">
                        <TabContent
                          activeTab={verticalActiveTab}
                          className="text-muted mt-4 mt-md-0"
                        >
                          <TabPane tabId="2">
                            <Card>
                              <CardBody>
                                <h5 className="mb-4">Clocking Method</h5>
                                <Form onSubmit={handleSubmitScheduler}>
                                  <div className="row mb-4">
                                    {/* Card 1 */}
                                    <div className="col-sm-4">
                                      <div className="card adjust-shadow">
                                        <div className="card-body">
                                          <h5 className="card-title">
                                            Geolocation
                                          </h5>
                                          <div className="d-flex flex-wrap">
                                            <img
                                              src={geolocationImg}
                                              alt="no"
                                              style={{
                                                width: '80px',
                                                height: '80px',
                                                paddingRight: 10,
                                              }}
                                            />
                                            <div
                                              className=""
                                              style={{
                                                maxWidth: 200,
                                              }}
                                            >
                                              <p className="card-text">
                                                With supporting text below as a
                                                natural lead-in to additional
                                                content.
                                              </p>
                                            </div>
                                            <div
                                              className=""
                                              style={{
                                                textAlign: 'right',
                                                width: '98%',
                                              }}
                                            >
                                              <input
                                                type="checkbox"
                                                name="enable_geolocation"
                                                checked={
                                                  settings.enable_geolocation
                                                }
                                                onChange={handleCheckboxChange}
                                                style={{
                                                  height: 20,
                                                  width: 20,
                                                  cursor: 'pointer',
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {/* Card 2 */}
                                    <div className="col-sm-4">
                                      <div className="card adjust-shadow">
                                        <div className="card-body">
                                          <h5 className="card-title">
                                            Geofencing
                                          </h5>
                                          <div className="d-flex flex-wrap">
                                            <img
                                              src={geofencingImg}
                                              alt="Geofencing"
                                              style={{
                                                width: '80px',
                                                height: '80px',
                                                paddingRight: 10,
                                              }}
                                            />
                                            <div
                                              className=""
                                              style={{
                                                maxWidth: 200,
                                              }}
                                            >
                                              <p className="card-text">
                                                With supporting text below as a
                                                natural lead-in to additional
                                                content.
                                              </p>
                                            </div>
                                            <div
                                              className=""
                                              style={{
                                                textAlign: 'right',
                                                width: '98%',
                                              }}
                                            >
                                              <input
                                                type="checkbox"
                                                name="enable_geofencing"
                                                checked={
                                                  settings.enable_geofencing
                                                }
                                                onChange={handleCheckboxChange}
                                                style={{
                                                  height: 20,
                                                  width: 20,
                                                  cursor: 'pointer',
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {/* Card 3 */}
                                    <div className="col-sm-4">
                                      <div className="card adjust-shadow">
                                        <div className="card-body">
                                          <h5 className="card-title">
                                            Tablet Biometrics
                                          </h5>
                                          <div className="d-flex flex-wrap">
                                            <img
                                              src={tabletbiometricsImg}
                                              alt="Tablet Biometrics"
                                              style={{
                                                width: '80px',
                                                height: '80px',
                                                paddingRight: 10,
                                              }}
                                            />
                                            <div
                                              className=""
                                              style={{
                                                maxWidth: 200,
                                              }}
                                            >
                                              <p className="card-text">
                                                With supporting text below as a
                                                natural lead-in to additional
                                                content.
                                              </p>
                                            </div>
                                            <div
                                              className=""
                                              style={{
                                                textAlign: 'right',
                                                width: '98%',
                                              }}
                                            >
                                              <input
                                                type="checkbox"
                                                name="enable_tablet_biometrics"
                                                checked={
                                                  settings.enable_tablet_biometrics
                                                }
                                                onChange={handleCheckboxChange}
                                                style={{
                                                  height: 20,
                                                  width: 20,
                                                  cursor: 'pointer',
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {settings.enable_geofencing === true && (
                                    <>
                                      <div className="container-fluid">
                                        {' '}
                                        {/* Use container-fluid for full width or container for fixed width */}
                                        <div className="row mt-3">
                                          <div className="col-sm-12">
                                            <strong>Site Map Address</strong>
                                            <input
                                              type="text"
                                              className="form-control mt-3 adjust-fs"
                                              value={siteMapSearchKey || ''}
                                              maxLength={25}
                                              placeholder="Search address or postal code"
                                              onChange={(e) =>
                                                siteMapSearchHandler(e)
                                              }
                                            />
                                            <MapProvider>
                                              <div className="navigate-container mt-3 d-flex flex-row justify-content-center align-items-center">
                                                {loading ? (
                                                  <div
                                                    style={{
                                                      textAlign: 'center',
                                                      padding: '10px',
                                                      backgroundColor:
                                                        'rgba(255, 255, 255, 0.8)',
                                                      borderRadius: '5px',
                                                    }}
                                                  >
                                                    Loading...
                                                  </div>
                                                ) : (
                                                  <NavigateButton />
                                                )}
                                              </div>
                                              <div
                                                style={{
                                                  height: '400px',
                                                  marginTop: '10px',
                                                  position: 'relative',
                                                }}
                                              >
                                                <Map
                                                  ref={mapRef}
                                                  {...viewport}
                                                  {...viewState}
                                                  id="siteMap"
                                                  onMove={(evt) =>
                                                    setViewState(evt.viewState)
                                                  }
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                  }}
                                                  mapStyle={MAP_BOX_API_URL}
                                                  mapboxAccessToken={
                                                    MAP_BOX_API_TOKEN
                                                  }
                                                >
                                                  {viewMarkerState && (
                                                    <>
                                                      {showPopup && (
                                                        <Popup
                                                          longitude={
                                                            viewMarkerState.longitude
                                                          }
                                                          latitude={
                                                            viewMarkerState.latitude
                                                          }
                                                          anchor="top"
                                                          onClose={() =>
                                                            setShowPopup(false)
                                                          }
                                                          closeOnClick={false}
                                                        >
                                                          <>
                                                            <span>{name}</span>
                                                            <br />
                                                            <span>
                                                              longitude:{' '}
                                                              {
                                                                viewMarkerState.longitude
                                                              }
                                                            </span>
                                                            <br />
                                                            <span>
                                                              latitude:{' '}
                                                              {
                                                                viewMarkerState.latitude
                                                              }
                                                            </span>
                                                          </>
                                                        </Popup>
                                                      )}
                                                      <FullscreenControl />
                                                      <NavigationControl />
                                                      <Marker
                                                        longitude={
                                                          viewMarkerState.longitude
                                                        }
                                                        latitude={
                                                          viewMarkerState.latitude
                                                        }
                                                        color="red"
                                                        draggable={true}
                                                        onDragEnd={(evt) =>
                                                          setMarkerState({
                                                            longitude:
                                                              evt.lngLat.lng,
                                                            latitude:
                                                              evt.lngLat.lat,
                                                          })
                                                        }
                                                        onClick={(evt) => {
                                                          setShowPopup(true);
                                                        }}
                                                      />
                                                      <GeolocateControl
                                                        fitBoundsOptions={{
                                                          padding: 10,
                                                        }}
                                                        trackUserLocation={true}
                                                        showUserHeading={true}
                                                        showAccuracyCircle={
                                                          false
                                                        }
                                                      />
                                                    </>
                                                  )}
                                                </Map>
                                              </div>
                                            </MapProvider>
                                          </div>
                                        </div>
                                        <div className="row my-3">
                                          <div className="col-sm-12">
                                            <strong>
                                              Site Distance Radius (Kilometers)
                                            </strong>
                                            <input
                                              type="text"
                                              className="form-control mt-3 w-25 adjust-fs"
                                              placeholder="Sample kilometer: 5000"
                                              value={siteMapDistance || ''}
                                              maxLength={25}
                                              onChange={(e) =>
                                                siteMapDistanceHandler(e)
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                  <div className="row">
                                    <div className="col">
                                      <Switch
                                        name="enable_capture_photo"
                                        checked={settings.enable_capture_photo}
                                        onChange={handleCheckboxChange}
                                      />
                                      <strong>Enable Capture Photo</strong>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col">
                                      <Switch
                                        name="enable_multiple_clockinout"
                                        checked={
                                          settings.enable_multiple_clockinout
                                        }
                                        onChange={handleCheckboxChange}
                                      />
                                      <strong>
                                        Enable Multiple Clock In/Out
                                      </strong>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col">
                                      <Switch
                                        name="enable_fix_break"
                                        checked={settings.enable_fix_break}
                                        onChange={handleCheckboxChange}
                                      />
                                      <strong>Enable Fix Break</strong>
                                    </div>
                                  </div>
                                  {settings.enable_fix_break && (
                                    <div
                                      style={{
                                        padding: '20px',
                                        maxWidth: '800px',
                                      }}
                                    >
                                      <div>
                                        <button
                                          onClick={(e) => addFixBreakCard(e)}
                                          className="btn btn-outline-brand rounded"
                                          style={{ marginBottom: '10px' }}
                                        >
                                          Add Fix Break
                                        </button>

                                        <DragDropContext
                                          onDragEnd={handleFixBreakDragEnd}
                                        >
                                          <Droppable droppableId="fixBreakCards">
                                            {(provided) => (
                                              <div
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}
                                                style={{
                                                  display: 'flex',
                                                  flexDirection: 'column',
                                                  gap: '10px',
                                                }}
                                              >
                                                {fixBreakCards.map(
                                                  (card, index) => (
                                                    <Draggable
                                                      key={card.id}
                                                      draggableId={card.id}
                                                      index={index}
                                                    >
                                                      {(provided) => (
                                                        <div
                                                          ref={
                                                            provided.innerRef
                                                          }
                                                          {...provided.draggableProps}
                                                          {...provided.dragHandleProps}
                                                          style={{
                                                            padding: '10px',
                                                            marginBottom:
                                                              '10px',
                                                            border:
                                                              '1px solid #ccc',
                                                            borderRadius: '5px',
                                                            ...provided
                                                              .draggableProps
                                                              .style,
                                                          }}
                                                        >
                                                          <div
                                                            style={{
                                                              display: 'flex',
                                                              alignItems:
                                                                'center',
                                                              gap: '10px',
                                                            }}
                                                          >
                                                            <select
                                                              value={
                                                                card.condition
                                                              }
                                                              className="form-select"
                                                              style={{
                                                                width: '180px',
                                                              }}
                                                              onChange={(e) =>
                                                                updateFixBreakCard(
                                                                  index,
                                                                  'condition',
                                                                  e.target.value
                                                                )
                                                              }
                                                            >
                                                              <option value="">
                                                                Select Condition
                                                              </option>
                                                              <option value="equal_to">
                                                                Equal To
                                                              </option>
                                                              <option value="greater_than">
                                                                Greater Than
                                                              </option>
                                                              <option value="less_than">
                                                                Less Than
                                                              </option>
                                                            </select>

                                                            <input
                                                              type="number"
                                                              className="form-control"
                                                              style={{
                                                                flex: 1,
                                                              }}
                                                              value={
                                                                card.work_hrs
                                                              }
                                                              onChange={(e) =>
                                                                updateFixBreakCard(
                                                                  index,
                                                                  'work_hrs',
                                                                  e.target.value
                                                                )
                                                              }
                                                              placeholder="Work Hours (0.00)"
                                                              step="0.01"
                                                              min="0"
                                                            />

                                                            <input
                                                              type="number"
                                                              className="form-control"
                                                              style={{
                                                                flex: 1,
                                                              }}
                                                              value={
                                                                card.break_mins
                                                              }
                                                              onChange={(e) =>
                                                                updateFixBreakCard(
                                                                  index,
                                                                  'break_mins',
                                                                  e.target.value
                                                                )
                                                              }
                                                              placeholder="Break Minutes (0.00)"
                                                              step="0.01"
                                                              min="0"
                                                            />

                                                            <button
                                                              onClick={() =>
                                                                removeFixBreakCard(
                                                                  index
                                                                )
                                                              }
                                                              className="btn btn-danger"
                                                              style={{
                                                                padding:
                                                                  '5px 10px',
                                                                fontSize:
                                                                  '14px',
                                                              }}
                                                            >
                                                              Remove
                                                            </button>
                                                          </div>
                                                        </div>
                                                      )}
                                                    </Draggable>
                                                  )
                                                )}
                                                {provided.placeholder}
                                              </div>
                                            )}
                                          </Droppable>
                                        </DragDropContext>
                                      </div>
                                    </div>
                                  )}
                                  <div className="row">
                                    <div className="col">
                                      <Switch
                                        name="enable_face_recognition"
                                        checked={
                                          settings.enable_face_recognition
                                        }
                                        onChange={handleCheckboxChange}
                                      />
                                      <strong>Enable Face Recognition</strong>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col">
                                      <Switch
                                        name="enable_preferred_schedule"
                                        checked={
                                          settings.enable_preferred_schedule
                                        }
                                        onChange={handleCheckboxChange}
                                      />
                                      <strong>Enable Preferred Schedule</strong>
                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col">
                                      <Switch
                                        name="enable_br_upload"
                                        checked={settings.enable_br_upload}
                                        onChange={handleCheckboxChange}
                                      />
                                      <strong>Enable Headcount Upload</strong>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col">
                                      <Switch
                                        name="enable_pick_rate"
                                        checked={settings.enable_pick_rate}
                                        onChange={handleCheckboxChange}
                                      />
                                      <strong>Enable Pick Rate</strong>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col">
                                      <Switch
                                        name="enable_credit_rewards"
                                        checked={settings.enable_credit_rewards}
                                        onChange={handleCheckboxChange}
                                      />
                                      <strong>Enable Credit Rewards</strong>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col">
                                      <Switch
                                        name="enable_schedule_upload"
                                        checked={
                                          settings.enable_schedule_upload
                                        }
                                        onChange={handleCheckboxChange}
                                      />
                                      <strong>Enable Schedule Upload</strong>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col">
                                      <Switch
                                        name="enable_auto_scheduling"
                                        checked={
                                          settings.enable_auto_scheduling
                                        }
                                        onChange={handleCheckboxChange}
                                      />
                                      <strong>Enable Auto-Scheduling</strong>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col">
                                      <Switch
                                        name="enable_assign_multiple_roles"
                                        checked={
                                          settings.enable_assign_multiple_roles
                                        }
                                        onChange={handleCheckboxChange}
                                      />
                                      <strong>
                                        Enable Assign Multiple Roles
                                      </strong>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col">
                                      <Switch
                                        name="enable_upload_timesheet"
                                        checked={
                                          settings.enable_upload_timesheet
                                        }
                                        onChange={handleCheckboxChange}
                                      />
                                      <strong>Enable Upload Timesheet</strong>
                                    </div>
                                  </div>
                                  {/* <div className="row">
                                    <div className="col">
                                      <Switch
                                        name="enable_cron_daily_tracker_report"
                                        checked={
                                          settings.enable_cron_daily_tracker_report
                                        }
                                        onChange={handleCheckboxChange}
                                      />
                                      <strong>
                                        Enable Send Daily Tracker Report
                                      </strong>
                                    </div>
                                  </div> */}
                                  {/* <div className="row">
                                    <div className="col">
                                      <Switch
                                        name="enable_cron_green_badge_report"
                                        checked={
                                          settings.enable_cron_green_badge_report
                                        }
                                        onChange={handleCheckboxChange}
                                      />
                                      <strong>
                                        Enable Send Green Badge Tracker Report
                                      </strong>
                                    </div>
                                  </div> */}
                                  {/* <div className="row">
                                    <div className="col">
                                      <Switch
                                        name="enable_cron_weekly_business_report"
                                        checked={
                                          settings.enable_cron_weekly_business_report
                                        }
                                        onChange={handleCheckboxChange}
                                      />
                                      <strong>
                                        Enable Send Weekly Business Review
                                        Report
                                      </strong>
                                    </div>
                                  </div> */}
                                  <div className="row">
                                    <div className="col">
                                      <Switch
                                        name="enable_dl_weekly_reports"
                                        checked={
                                          settings.enable_dl_weekly_reports
                                        }
                                        onChange={handleCheckboxChange}
                                      />
                                      <strong>
                                        Enable Download Weekly Reports
                                      </strong>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col">
                                      <Switch
                                        name="enable_dl_monthly_reports"
                                        checked={
                                          settings.enable_dl_monthly_reports
                                        }
                                        onChange={handleCheckboxChange}
                                      />
                                      <strong>
                                        Enable Download Monthly Reports
                                      </strong>
                                    </div>
                                  </div>

                                  {/* <div className="default-schedule-container">
                                    <h6>Default Fixed Schedule</h6>
                                    <div className="row mt-3">
                                      <div className="col">
                                        <table className="table table-bordered">
                                          <thead>
                                            <tr>
                                              <th>Days</th>
                                              <th colSpan="3">Shift</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {Object.keys(schedule).map(
                                              (day) => (
                                                <tr key={day}>
                                                  <td>{day}</td>
                                                  <td>
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      placeholder="Start Time"
                                                      value={
                                                        schedule[day].startTime
                                                      }
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          day,
                                                          'startTime',
                                                          e.target.value
                                                        )
                                                      }
                                                      name={`${day}-startTime`}
                                                    />
                                                  </td>
                                                  <td
                                                    style={{
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                    }}
                                                  >
                                                    to
                                                  </td>
                                                  <td>
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      placeholder="End Time"
                                                      value={
                                                        schedule[day].endTime
                                                      }
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          day,
                                                          'endTime',
                                                          e.target.value
                                                        )
                                                      }
                                                      name={`${day}-endTime`}
                                                    />
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div> */}

                                  <div className="row">
                                    <div className="col">
                                      <Switch
                                        name="enable_roll_calls"
                                        checked={settings.enable_roll_calls}
                                        onChange={handleCheckboxChange}
                                      />
                                      <strong>Enable Roll Calls</strong>
                                    </div>
                                  </div>

                                  {settings.enable_roll_calls && (
                                    <div
                                      style={{
                                        padding: '20px',
                                        maxWidth: '600px',
                                      }}
                                    >
                                      <div>
                                        {' '}
                                        <button
                                          onClick={(e) => addRollCallCard(e)}
                                          className="btn btn-outline-brand rounded"
                                          style={{ marginBottom: '10px' }}
                                        >
                                          Add Roll Calls
                                        </button>
                                        <DragDropContext
                                        // onDragEnd={handleDragEnd}
                                        >
                                          <Droppable droppableId="rollCallCards">
                                            {(provided) => (
                                              <div
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}
                                                style={{
                                                  display: 'flex',
                                                  flexDirection: 'column',
                                                  gap: '10px',
                                                }}
                                              >
                                                {rollCallCards.map(
                                                  (cardData, index) => (
                                                    <Draggable
                                                      key={cardData.id}
                                                      draggableId={
                                                        cardData.id +
                                                        '_rollcall'
                                                      }
                                                      index={index}
                                                      isDragDisabled={true}
                                                    >
                                                      {(provided) => (
                                                        <div
                                                          ref={
                                                            provided.innerRef
                                                          }
                                                          {...provided.draggableProps}
                                                          {...provided.dragHandleProps}
                                                          style={{
                                                            padding: '10px',
                                                            marginBottom:
                                                              '10px',
                                                            border:
                                                              '1px solid #ccc',
                                                            borderRadius: '5px',
                                                            ...provided
                                                              .draggableProps
                                                              .style,
                                                          }}
                                                        >
                                                          <div
                                                            style={{
                                                              alignItems:
                                                                'center',
                                                              gap: '10px',
                                                            }}
                                                          >
                                                            <div className="row">
                                                              <div className="col-6">
                                                                <strong
                                                                  style={{
                                                                    fontSize: 12,
                                                                  }}
                                                                >
                                                                  Status
                                                                </strong>
                                                                <select
                                                                  value={
                                                                    cardData.status
                                                                  }
                                                                  className="form-select"
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    updateRollCallCard(
                                                                      index,
                                                                      'status',
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                >
                                                                  <option value="">
                                                                    Select
                                                                  </option>
                                                                  <option value="0">
                                                                    Disable
                                                                  </option>
                                                                  <option value="1">
                                                                    Enable
                                                                  </option>
                                                                </select>
                                                              </div>
                                                              <div className="col-1">
                                                                &nbsp;
                                                              </div>
                                                              <div className="col-5">
                                                                <strong
                                                                  style={{
                                                                    fontSize: 12,
                                                                  }}
                                                                >
                                                                  Display before
                                                                  shift (In Hrs)
                                                                </strong>
                                                                <input
                                                                  type="number"
                                                                  className="form-control"
                                                                  placeholder="Enter Hours"
                                                                  value={
                                                                    cardData.hours
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    updateRollCallCard(
                                                                      index,
                                                                      'hours',
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                />
                                                              </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                              <div className="col-md-12">
                                                                <strong
                                                                  style={{
                                                                    fontSize: 12,
                                                                  }}
                                                                >
                                                                  Title
                                                                </strong>
                                                                <input
                                                                  type="text"
                                                                  className="form-control"
                                                                  placeholder="Enter Title"
                                                                  value={
                                                                    cardData.title
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    updateRollCallCard(
                                                                      index,
                                                                      'title',
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                />
                                                              </div>
                                                            </div>
                                                            <div className="row">
                                                              <div className="col-md-12 mt-2">
                                                                <strong
                                                                  style={{
                                                                    fontSize: 12,
                                                                  }}
                                                                >
                                                                  Message
                                                                </strong>
                                                                <textarea
                                                                  rows="10"
                                                                  className="form-control mb-3"
                                                                  style={{
                                                                    resize:
                                                                      'none',
                                                                  }}
                                                                  placeholder="Enter Message"
                                                                  value={
                                                                    cardData.message
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    updateRollCallCard(
                                                                      index,
                                                                      'message',
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                />
                                                              </div>
                                                            </div>

                                                            <div className="row">
                                                              <div className="col-md-12 text-end">
                                                                <button
                                                                  onClick={() =>
                                                                    removeRollCallCard(
                                                                      index
                                                                    )
                                                                  }
                                                                  className="btn btn-danger"
                                                                  style={{
                                                                    padding:
                                                                      '5px 10px',
                                                                    fontSize:
                                                                      '14px',
                                                                  }}
                                                                >
                                                                  Remove
                                                                </button>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      )}
                                                    </Draggable>
                                                  )
                                                )}
                                                {provided.placeholder}
                                              </div>
                                            )}
                                          </Droppable>
                                        </DragDropContext>
                                      </div>
                                    </div>
                                  )}

                                  <div className="row">
                                    <div className="col">
                                      <Switch
                                        name="enable_checklist"
                                        checked={settings.enable_checklist}
                                        onChange={handleCheckboxChange}
                                      />
                                      <strong>Enable Checklist</strong>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      padding: '20px',
                                      maxWidth: '600px',
                                    }}
                                  >
                                    {settings.enable_checklist && (
                                      <div>
                                        {' '}
                                        <button
                                          onClick={(e) => addCard(e)}
                                          className="btn btn-outline-brand rounded"
                                          style={{ marginBottom: '10px' }}
                                        >
                                          Add Card
                                        </button>
                                        <DragDropContext
                                          onDragEnd={handleDragEnd}
                                        >
                                          <Droppable droppableId="cards">
                                            {(provided) => (
                                              <div
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}
                                                style={{
                                                  display: 'flex',
                                                  flexDirection: 'column',
                                                  gap: '10px',
                                                }}
                                              >
                                                {cards.map((card, index) => (
                                                  <Draggable
                                                    key={card.id}
                                                    draggableId={card.id}
                                                    index={index}
                                                  >
                                                    {(provided) => (
                                                      <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={{
                                                          padding: '10px',
                                                          marginBottom: '10px',
                                                          border:
                                                            '1px solid #ccc',
                                                          borderRadius: '5px',
                                                          ...provided
                                                            .draggableProps
                                                            .style,
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: 'flex',
                                                            alignItems:
                                                              'center',
                                                            gap: '10px',
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            className="form-control"
                                                            style={{ flex: 1 }}
                                                            value={card.text}
                                                            onChange={(e) =>
                                                              updateCard(
                                                                index,
                                                                'text',
                                                                e.target.value
                                                              )
                                                            }
                                                            placeholder="Enter text"
                                                          />
                                                          <select
                                                            value={
                                                              card.dropdownValue
                                                            }
                                                            className="form-select"
                                                            style={{
                                                              width: '200px',
                                                            }}
                                                            onChange={(e) =>
                                                              updateCard(
                                                                index,
                                                                'dropdownValue',
                                                                e.target.value
                                                              )
                                                            }
                                                          >
                                                            <option value="">
                                                              Select
                                                            </option>
                                                            <option value="textbox">
                                                              textbox
                                                            </option>
                                                            <option value="decimal">
                                                              decimal
                                                            </option>
                                                            <option value="dropdown">
                                                              dropdown
                                                            </option>
                                                          </select>
                                                          <button
                                                            onClick={() =>
                                                              removeCard(index)
                                                            }
                                                            className="btn btn-danger"
                                                            style={{
                                                              padding:
                                                                '5px 10px',
                                                              fontSize: '14px',
                                                            }}
                                                          >
                                                            Remove
                                                          </button>
                                                        </div>

                                                        {/* Render options if dropdown is selected */}
                                                        {card.dropdownValue ===
                                                          'dropdown' && (
                                                          <div
                                                            style={{
                                                              marginTop: '10px',
                                                            }}
                                                          >
                                                            <div
                                                              style={{
                                                                display: 'flex',
                                                                alignItems:
                                                                  'center',
                                                                gap: '10px',
                                                                marginTop:
                                                                  '20px',
                                                                marginBottom:
                                                                  '10px',
                                                                marginLeft:
                                                                  '20px', // Adjust the left margin here
                                                              }}
                                                            >
                                                              <button
                                                                onClick={(e) =>
                                                                  addOption(
                                                                    e,
                                                                    index
                                                                  )
                                                                }
                                                                className="btn btn-outline-brand rounded"
                                                              >
                                                                Add Option
                                                              </button>
                                                            </div>

                                                            {card.options.map(
                                                              (
                                                                option,
                                                                optionIndex
                                                              ) => (
                                                                <div
                                                                  key={
                                                                    optionIndex
                                                                  }
                                                                  style={{
                                                                    display:
                                                                      'flex',
                                                                    alignItems:
                                                                      'center',
                                                                    gap: '10px',
                                                                    marginBottom:
                                                                      '10px',
                                                                    marginLeft:
                                                                      '20px', // Adjust the left margin here
                                                                  }}
                                                                >
                                                                  <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    style={{
                                                                      flex: 1,
                                                                    }}
                                                                    value={
                                                                      option.option_value
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      updateOption(
                                                                        index,
                                                                        optionIndex,
                                                                        'option_value',
                                                                        e.target
                                                                          .value
                                                                      )
                                                                    }
                                                                    placeholder="Option Value"
                                                                  />
                                                                  <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    style={{
                                                                      flex: 1,
                                                                    }}
                                                                    value={
                                                                      option.option_label
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      updateOption(
                                                                        index,
                                                                        optionIndex,
                                                                        'option_label',
                                                                        e.target
                                                                          .value
                                                                      )
                                                                    }
                                                                    placeholder="Option Label"
                                                                  />
                                                                  <button
                                                                    onClick={() =>
                                                                      removeOption(
                                                                        index,
                                                                        optionIndex
                                                                      )
                                                                    }
                                                                    className="btn btn-danger"
                                                                    style={{
                                                                      padding:
                                                                        '5px 10px',
                                                                      fontSize:
                                                                        '14px',
                                                                    }}
                                                                  >
                                                                    Remove
                                                                  </button>
                                                                </div>
                                                              )
                                                            )}
                                                          </div>
                                                        )}
                                                      </div>
                                                    )}
                                                  </Draggable>
                                                ))}
                                                {provided.placeholder}
                                              </div>
                                            )}
                                          </Droppable>
                                        </DragDropContext>
                                      </div>
                                    )}
                                  </div>

                                  <div className="d-flex justify-content-end">
                                    <button
                                      type="submit"
                                      className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                                      style={{ width: '12rem' }}
                                    >
                                      Save changes
                                    </button>
                                  </div>
                                </Form>
                              </CardBody>
                            </Card>
                          </TabPane>
                          <TabPane tabId="3">
                            <Form
                              noValidate
                              validated={validated}
                              onSubmit={handleSubmitAnnouncement}
                            >
                              <h5 className="m-2">Announcement</h5>
                              {isEditing ? (
                                <div className="border m-2 mt-3">
                                  <div
                                    className="flex-grow-1 bg-white"
                                    style={{ padding: '2.25rem' }}
                                  >
                                    <h6>
                                      {formData.id ? 'Edit' : 'Add New'}{' '}
                                      Announcement
                                    </h6>
                                    <div className="row mt-3">
                                      <div className="col-sm-6">
                                        <strong>Name</strong>
                                        <input
                                          required
                                          type="text"
                                          className="form-control mt-2 adjust-fs"
                                          value={announcementName}
                                          maxLength={255}
                                          onChange={(e) =>
                                            announcementNameHandler(e)
                                          }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          Please enter name.
                                        </Form.Control.Feedback>
                                      </div>
                                      <div className="col-sm-6">
                                        <strong>Status</strong>
                                        <select
                                          value={announcementStatus}
                                          className="form-select mt-2 adjust-fs"
                                          onChange={(e) =>
                                            announcementStatusHandler(e)
                                          }
                                        >
                                          <option value="">Select</option>
                                          <option value="0">Inactive</option>
                                          <option value="1">Active</option>
                                        </select>
                                      </div>
                                    </div>
                                    <div className="row mt-3">
                                      <div className="col-sm-6">
                                        <strong className="mb-2 adjust-fs">
                                          Display From
                                        </strong>
                                        <DatePicker
                                          selected={startDate}
                                          onChange={(date) =>
                                            setStartDate(date)
                                          }
                                          selectsStart
                                          startDate={startDate}
                                          endDate={endDate}
                                          placeholderText="Display From"
                                          dateFormat="dd/MM/yyyy"
                                          style={{
                                            borderRadius: '.375rem',
                                            borderColor: '#dee2e6',
                                            width: '100%',
                                          }}
                                          customInput={
                                            <CustomInput placeholder="Select a date" />
                                          }
                                        />
                                      </div>
                                      <div className="col-sm-6">
                                        <strong className="mb-2 adjust-fs">
                                          Display To
                                        </strong>
                                        <DatePicker
                                          selected={endDate}
                                          onChange={(date) => setEndDate(date)}
                                          selectsEnd
                                          startDate={startDate}
                                          endDate={endDate}
                                          minDate={startDate} // Prevent selecting an end date before start date
                                          placeholderText="Display To"
                                          dateFormat="dd/MM/yyyy"
                                          style={{
                                            borderRadius: '.375rem',
                                            borderColor: '#dee2e6',
                                            width: '100%',
                                          }}
                                          customInput={
                                            <CustomInput placeholder="Select a date" />
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="row mt-3 mb-3">
                                      <div className="col-sm-12">
                                        <strong>Message</strong>
                                        <textarea
                                          className="form-control mt-2 adjust-fs"
                                          rows="5"
                                          style={{ resize: 'none' }}
                                          placeholder="Messsage"
                                          id="Messsage"
                                          name="Messsage"
                                          value={messsage}
                                          onChange={(e) => messageHandler(e)}
                                        />
                                      </div>
                                    </div>

                                    <div className="row mt-3 mb-3">
                                      <div className="col-sm-12">
                                        <strong>CN Message (Chinese)</strong>
                                        <textarea
                                          className="form-control mt-2 adjust-fs"
                                          rows="5"
                                          style={{ resize: 'none' }}
                                          placeholder="CN Message"
                                          id="CnMessage"
                                          name="CnMessage"
                                          value={cnMessage}
                                          onChange={(e) => cnMessageHandler(e)}
                                        />
                                      </div>
                                    </div>

                                    <div className="d-flex justify-content-end">
                                      <button
                                        type="button"
                                        onClick={handleCancel}
                                        className="btn btn-outline-brand adjust-fs adjust-shadow"
                                        style={{ width: '12rem' }}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        type="submit"
                                        className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                                        style={{ width: '12rem' }}
                                      >
                                        Save changes
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <>
                                  <div className="text-end mb-2">
                                    <button
                                      onClick={handleAdd}
                                      className="btn btn-outline-brand adjust-fs adjust-shadow"
                                      style={{ width: '200px' }}
                                    >
                                      Add New Announcement
                                    </button>
                                  </div>
                                  <div className="table-responsive rounded shadow bg-white">
                                    <Box sx={{ width: '100%' }}>
                                      <DataGrid
                                        columns={columns}
                                        rows={data || []}
                                        rowCount={totalRows || 1}
                                        loading={loadingAnnouncement}
                                        pageSizeOptions={[
                                          10, 20, 30, 40, 50, 80, 100,
                                        ]}
                                        paginationModel={paginationModel}
                                        paginationMode="server"
                                        onPaginationModelChange={
                                          setPaginationModel
                                        }
                                        initialState={{
                                          pagination: {
                                            paginationModel: {
                                              page: 0,
                                              pageSize: 10,
                                            },
                                          },
                                        }}
                                        localeText={{ noRowsLabel: '' }}
                                        sortModel={sortModel}
                                        onSortModelChange={
                                          handleSortModelChange
                                        }
                                        // getRowHeight={() => 'auto'}
                                        disableSelectionOnClick
                                        isRowSelectable={() => false}
                                      />
                                    </Box>
                                  </div>
                                </>
                              )}
                            </Form>
                          </TabPane>
                          {client && client.enable_claims && (
                            <TabPane tabId="4">
                              <Card>
                                <CardBody>
                                  <h5 className="mb-4">Claims Setting</h5>
                                  <Form
                                    validated={validated}
                                    onSubmit={handleSubmitClaimSettingsHandler}
                                  >
                                    <div className="row">
                                      <div className="col">
                                        <Switch
                                          name="enable_claim_limit"
                                          checked={
                                            settings.enable_claim_limit ?? false
                                          }
                                          onChange={handleCheckboxChange}
                                        />
                                        <strong>Enable Claims Limit</strong>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col">
                                        <Switch
                                          name="enable_claim_percentage"
                                          checked={
                                            settings.enable_claim_percentage ??
                                            false
                                          }
                                          onChange={handleCheckboxChange}
                                        />
                                        <strong>
                                          Enable Claims Percentage (%)
                                        </strong>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col">
                                        <Switch
                                          name="enable_claim_receipt"
                                          checked={
                                            settings.enable_claim_receipt ??
                                            false
                                          }
                                          onChange={handleCheckboxChange}
                                        />
                                        <strong>
                                          Enable Claim No. of Receipts
                                        </strong>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col">
                                        <Switch
                                          name="enable_ss_claim_limit"
                                          checked={
                                            settings.enable_ss_claim_limit ??
                                            false
                                          }
                                          onChange={handleCheckboxChange}
                                        />
                                        <strong>
                                          Enable Safety Shoes Claims Limit
                                        </strong>
                                      </div>
                                    </div>
                                    <Card className="shadow-sm my-4">
                                      <CardHeader>
                                        <div className="d-flex justify-content-between align-items-center py-2">
                                          <h6 className="mb-0">
                                            Approval Flow
                                          </h6>
                                        </div>

                                        <button
                                          onClick={addApprover}
                                          className="btn btn-outline-brand ms-3 adjust-fs adjust-shadow claim-approver"
                                        >
                                          Add New Approver
                                        </button>
                                      </CardHeader>
                                      <CardBody>
                                        {claimApprovers &&
                                        claimApprovers.length > 0 ? (
                                          claimApprovers.map(
                                            (approver, index) => (
                                              <div
                                                key={approver.id}
                                                className="mt-2 mb-4 p-3 border rounded"
                                              >
                                                <div className="row align-items-center">
                                                  <div className="col-md-3">
                                                    <label className="form-label fw-bold mb-0">
                                                      Approver {index + 1}
                                                    </label>
                                                  </div>
                                                  <div className="col-md-6">
                                                    <select
                                                      className="form-select"
                                                      value={approver.value}
                                                      onChange={(e) =>
                                                        handleApproverChange(
                                                          approver.id,
                                                          e.target.value
                                                        )
                                                      }
                                                    >
                                                      <option value="">
                                                        Select an approver
                                                      </option>
                                                      <option value="client">
                                                        Client
                                                      </option>
                                                      <option value="admin">
                                                        Admin
                                                      </option>
                                                    </select>
                                                  </div>
                                                  <div className="col-md-3">
                                                    <button
                                                      className="btn p-0 text-danger"
                                                      onClick={(e) => {
                                                        e.preventDefault(); // Prevent default button behavior
                                                        removeApprover(
                                                          approver.id
                                                        );
                                                      }}
                                                    >
                                                      <i className="fas fa-trash"></i>
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            )
                                          )
                                        ) : (
                                          <div
                                            className="text-center p-4"
                                            style={{ marginTop: '20px' }}
                                          >
                                            No Records Found
                                          </div>
                                        )}
                                      </CardBody>
                                    </Card>

                                    <div className="text-end mb-2">
                                      <button
                                        type="submit"
                                        className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                                        style={{ width: '12rem' }}
                                      >
                                        Save changes
                                      </button>
                                    </div>
                                  </Form>
                                </CardBody>
                              </Card>
                            </TabPane>
                          )}
                        </TabContent>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          ) : (
            ''
          )}
        </div>

        {/* <div
          className="card bg-white text-dark shadow rounded d-flex flex-column"
          style={{
            marginTop: '3rem',
            marginRight: '3rem',
            marginBottom: '3rem',
            width: '17rem',
            minWidth: '17rem',
          }}
        >
          <div className="card-body">
            <div className="container-fluid d-flex flex-column m-2">
              <div className="d-flex flex-column pb-4">
                <div className="border-bottom pb-3 mb-3">
                  <h5>Manager Information</h5>
                </div>
                <div className="pb-2">Name</div>
                <strong className="pb-2"> {site.manager_name}</strong>
                <div className="pb-2">Email</div>
                <strong className="pb-2">{site.manager_email}</strong>
                <div className="pb-2">Contact</div>
                <strong className="pb-2">{site.manager_phone_no}</strong>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default withRouter(SiteDetail);
